<template lang="pug">
.container-restricao
    div(
        v-if='restricoes.length > 0',
        :class='restricoes[index].inibido ? "camada-inibida" : ""',
        v-for='(restricao, index) in listaRestricoes',
        :key="index"
    )
        slot(name='botaoInibir', :restricao='restricoes[index]')
        .card-restricao
            .container-restricao-acoes(
                v-if='existeDadosGeoEspaciais(restricoes[index])'
            )
                div
                    el-button(
                        size='small',
                        icon='mdi mdi-crosshairs-gps',
                        @click='aplicarZoomRestricao(index)'
                    )
            p
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.areaGeometriaAnalisadaHa') }}:
                | {{ restricao?.areaGeometriaAnalisadaHa ? Number(restricao.areaGeometriaAnalisadaHa).toFixed(2) : restricao?.properties?.areaGeometriaAnalisadaHa ? Number(restricao.properties.areaGeometriaAnalisadaHa).toFixed(2) : '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.areaTotalFeatureHa') }}:
                |  {{ formatNumber(restricao.areaTotalFeatureHa || restricao?.properties?.areaTotalFeatureHa) || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.percentualSobreposicaoGeometria') }}:
                |  {{ restricao.percentualSobreposicaoGeometria || restricao?.properties?.percentualSobreposicaoGeometria || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.areaHa') }}:
                | {{ restricao?.areaHa ? Number(restricao.areaHa).toFixed(2) : restricao?.properties?.areaHa ? Number(restricao.properties.areaHa).toFixed(2) : '-' }}
                br
</template>

<script>
export default {
    name: 'area-plantada-soja-paraguai-2025-2026',

    props: {
        restricoes: {
            type: Array,
            required: true
        },
        geometria: {
            type: Array,
            required: false,
            default: null
        },
        habilitarZoomRestricao: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    computed: {
        listaRestricoes() {
            return this.restricoes.map(value => {
                if (value && value.properties) {
                    return { ...value.properties };
                }
                return value || {};
            });
        }
    },

    methods: {
        aplicarZoomRestricao(index) {
            let geometriaQueNaoEstavaDentroDasRestricoes = null;
            if (this.geometria) {
                geometriaQueNaoEstavaDentroDasRestricoes = this.geometria[index];
            }
            this.$emit(
                'aplicar-zoom-restricao',
                this.restricoes[index],
                geometriaQueNaoEstavaDentroDasRestricoes,
                index
            );
        },

        formatNumber(number) {
            return number !== undefined && number !== null && number !== ''
                ? Number(number).toLocaleString('pt-BR', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                  })
                : '-';
        },

        existeDadosGeoEspaciais(restricao) {
            const { geometry, geometria, properties } = restricao || {};
            if (properties?.latitude && properties?.longitude) {
                return true;
            }
            return (
                this.habilitarZoomRestricao &&
                (geometry || geometria || this.geometria)
            );
        }
    }
};
</script>

<style scoped>
.container-restricao {
    margin-bottom: 10px;
}
.card-restricao {
    padding: 8px 12px;
    background: #f8f8f8;
    border-radius: 6px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.container-restricao-acoes {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 4px;
}
.camada-inibida {
    opacity: 0.5;
}
</style>
